module.exports = __webpack_public_path__ + "img/cosco.bec40862.png";